//---- components ---------
//---- mixins -------------
//---- services -----------
import i18n from "@/app/services/i18n.service.js"
//---- other --------------
//---- 3rd-parties --------
import {
    ValidationObserver,
    ValidationProvider,
    extend,
    configure,
} from "vee-validate";
import { email, min_value, max_value, max, oneOf, required, integer, double, numeric, regex } from "vee-validate/dist/rules";
import Vue from 'vue';


// Available rules are:
// alpha, alpha_dash, alpha_num, alpha_spaces, between, confirmed, digits, 
// dimensions, double, email, excluded, ext, image, integer, is, is_not, 
// length, max, max_value, mimes, min, min_value, numeric, oneOf, regex, 
// required, required_if, size

configure({
    defaultMessage: (field, values) => {
        // override the field name.
        // values._field_ = i18n.t(`fields.${field}`);

        return i18n.t(`validation.${values._rule_}`, values);
    }
});


// Install default rules and messages.
extend("regex", regex);
extend("integer", integer);
extend("numeric", numeric);
extend("double", double);
extend("email", email);
extend("max", max);
extend("min_value", min_value);
extend("max_value", max_value);
extend("oneOf", oneOf);
extend("required", required);

// install extra rules and messages.

// passwords must be identical
extend('password', {
    params: ['target'],
    validate(value, { target }) {
        return value === target;
    },
});

// Install VeeValidate components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

// setInteractionMode("eager");
